<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :stripe="false"
      :selection="hasBtn && selection"
      right-toolbar-hide
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessOrderAuditComSkuList.receivingStatus')" prop="receiveStatus">
            <BjSelectLov
              v-model="queryParams.receiveStatus"
              constant-key="ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST"
            />
          </el-form-item>
        </el-col>

        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.deliveryStatus')" prop="deliveryStatus">
              <BjSelectLov
                v-model="queryParams.deliveryStatus"
                constant-key="ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.preemptionStatus')" prop="preemptionStatus">
              <BjSelectLov
                v-model="queryParams.preemptionStatus"
                constant-key="ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.sourceStatus')" prop="sourceStatus">
              <BjSelectLov
                v-model="queryParams.sourceStatus"
                constant-key="ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.suspendStatus')" prop="suspendStatus">
              <BjSelectLov
                v-model="queryParams.suspendStatus"
                constant-key="ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.syncPreempStatus')" prop="syncPreempStatus">
              <BjSelectLov
                v-model="queryParams.syncPreempStatus"
                constant-key="ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessOrderAuditComSkuList.syncDeliveryStatus')" prop="syncDeliveryStatus">
              <BjSelectLov
                v-model="queryParams.syncDeliveryStatus"
                constant-key="ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST"
              />
            </el-form-item> </el-col
        ></template>
      </template>
      <template v-if="hasBtn" #startBtnGroup>
        <!-- TODO:添加商品 -->
        <!-- <el-button type="primary" @click="onAction('添加商品')">添加商品</el-button> -->
        <!-- 1.点击时验证选择的商品行状态，如果商品行审核状态非待审核则报错，请选择待审核的商品 -->
        <!-- <el-button type="primary" @click="onAction('审核通过')" class="main-btn">审核通过</el-button>
        <el-button type="primary" @click="onAction('审核拒绝')">审核拒绝</el-button>
        <el-button type="primary" @click="onAction('退回审核')">退回审核</el-button> -->
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.receipt'))">{{ $t('BusinessOrderAuditComSkuList.receipt') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.hangUp'))">{{ $t('BusinessOrderAuditComSkuList.hangUp') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderAuditComSkuList.hang'))">{{ $t('BusinessOrderAuditComSkuList.hang') }}</el-button>
      </template>

      <template v-slot:tableColumn>
        <el-table-column prop="skuCode" :label="$t('goodsPage.skuCode')" align="center" width="114"> </el-table-column>
        <el-table-column prop="giftFlag" :label="$t('BusinessOrderAuditComSkuList.giftFlag')" align="center" width="86">
          <template slot-scope="scope">
            <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
              $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('BusinessOrderAuditComSkuList.quantity')" align="center" width="81"> </el-table-column>

        <el-table-column prop="thirdSaleAmount" :label="$t('BusinessOrderAuditComSkuList.thirdSaleAmount')" align="center" width="159"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.thirdSaleAmount) }}
          </template></el-table-column
        >
        <el-table-column prop="outBalancePrice" :label="$t('BusinessOrderAuditComSkuList.outBalancePrice')" align="center" width="192"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.outBalancePrice) }}
          </template></el-table-column
        >
        <el-table-column prop="innerSalePrice" :label="$t('BusinessOrderAuditComSkuList.innerSalePrice')" align="center" width="111"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.innerSalePrice) }}
          </template></el-table-column
        >

        <el-table-column prop="innerBalancePrice" :label="$t('BusinessOrderAuditComSkuList.innerBalancePrice')" align="center" width="159"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.innerBalancePrice) }}
          </template></el-table-column
        >
        <el-table-column prop="costAmount" :label="$t('BusinessOrderAuditComSkuList.costAmount')" align="center" width="81"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.costAmount) }}
          </template></el-table-column
        >
        <el-table-column prop="totalCostAmount" :label="$t('BusinessOrderAuditComSkuList.totalCostAmount')" align="center" width="86"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.totalCostAmount) }}
          </template></el-table-column
        ><el-table-column prop="transPrice" :label="$t('BusinessOrderAuditComSkuList.transPrice')" align="center" width="74"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.transPrice) }}
          </template></el-table-column
        >
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-table-column prop="deliveryStatus" :label="$t('BusinessOrderAuditComSkuList.deliveryStatus')" align="center" width="114"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST.bjGet(scope.row.deliveryStatus)) }}
            </template></el-table-column
          >
        </template>

        <el-table-column prop="receivingStatus" :label="$t('BusinessOrderAuditComSkuList.receivingStatus')" align="center" width="109"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST.bjGet(scope.row.receivingStatus)) }}
          </template></el-table-column
        >

        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <!-- #ifndef OPEN-SOURCE -->
          <el-table-column prop="preemptionStatus" :label="$t('BusinessOrderAuditComSkuList.preemptionStatus')" align="center" width="180"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(scope.row.preemptionStatus)) }}
            </template></el-table-column
          >
          <el-table-column prop="sourceStatus" :label="$t('BusinessOrderAuditComSkuList.sourceStatus')" align="center" width="171"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourceStatus)) }}
            </template></el-table-column
          >
          <!-- #endif -->
          <el-table-column prop="suspendStatus" :label="$t('BusinessOrderAuditComSkuList.hangUp')" align="center" width="142"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(scope.row.suspendStatus)) }}
            </template></el-table-column
          >
          <!-- #ifndef OPEN-SOURCE -->
          <el-table-column prop="syncPreempStatus" :label="$t('BusinessOrderAuditComSkuList.syncPreempStatus')" align="center" width="173"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST.bjGet(scope.row.syncPreempStatus)) }}
            </template></el-table-column
          >
          <!-- #endif -->
          <el-table-column prop="syncDeliveryStatus" :label="$t('BusinessOrderAuditComSkuList.syncDeliveryStatus')" align="center" width="181"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST.bjGet(scope.row.syncDeliveryStatus)) }}
            </template></el-table-column
          ></template
        >
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuLineList',
  components: {},
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },
  data() {
    return {
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuLineListByAuditId,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        // isOutStock: null,
        refundFlag: null,
        auditId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,
      // labelList: [
      //   { label: '网店编码', prop: 'code', isCheck: true, disabled: false },
      //   { label: '网店名称', prop: 'name', isCheck: true, disabled: false },
      //   { label: '销售渠道', prop: 'channelTypeMeaning', isCheck: true, disabled: false },
      //   // { label: '网店状态', prop: 'status', isCheck: true, disabled: false },
      //   { label: '所属公司', prop: 'orgName', isCheck: true, disabled: false },
      //   { label: '网店类型', prop: 'onlineStoreTypeMeaning', isCheck: true, disabled: false },
      //   // { label: '店铺地址', prop: 'url', isCheck: true, disabled: false },

      //   { label: '渠道仓名称', prop: 'channelWarehouseName', isCheck: true, disabled: false },
      //   { label: '渠道仓状态', prop: 'status', isCheck: true, disabled: false },
      //   { label: 'table.createdByText', prop: 'createdName', isCheck: true, disabled: false, width: 135 },
      //   { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 135 },
      //   { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      // ],
      selectedRows: null,
    };
  },
  watch: {},
  created() {
    this.queryParams.auditId = this.orderId;
  },
  methods: {
    onAction(action) {
      const hasChildren = false;
      this.$emit('onAction', action, hasChildren, this.selectedRows);
    },
  },
};
</script>
